import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterDepositReportFranchise from 'views/reports/depositReportFranchise/filterDepositReportFranchise'; // Importing filter for the franchise deposit report
import TableDepositReportFranchise from 'views/reports/depositReportFranchise/tableDepositReportFranchise'; // Importing table for the franchise deposit report

/**
 * Container view for "Reporte de Depósitos por Franquicias".
 * @extends JetView
 */
export default class DepositReportFranchiseView extends JetView {
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Title bar, filter panel and report table, stacked in a single column
        const left = {
            css: 'int-left',
            gravity: 1,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the report title
                    css: theme,
                    elements: [{ view: 'label', label: _('Reporte de Depósitos por Franquicias') }], // Title label
                },
                FilterDepositReportFranchise, // Filter component for the franchise deposit report
                TableDepositReportFranchise, // Table component for the franchise deposit report
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration for the franchise deposit report view
        return {
            id: 'a5franchise',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5franchise',
                    type: 'wide',
                    cols: [left], // Single column with filter and table
                },
            ],
        };
    }
}

// FILE DOCUMENTED
